export const saveAtWindow = (key: string, value: any) => {
	const newObj = { [key]: value };
	const prevWidnowData = (window as any).windowData ?? {};
	(window as any).windowData = Object.assign(prevWidnowData, newObj);
};

export const retrieveFromWindow = (key: string) =>
	(window as any)?.windowData?.[key];
